$('.blog_menu li').click(function(event){
  event.preventDefault();
  $(this).siblings().find('label').removeClass('active_link');
  $(this).find('label').addClass('active_link');
  var target = $(this).attr('href');
  console.log(target);
  if(target == 'all'){
    $('.blog-with-meta-objects').removeClass("blog-showing-all")
    $('.single-blog-item').show()
    $('.feature_blogg').show();
  }else{
    $('.blog-with-meta-objects').removeClass("blog-showing-all")
    $('.single-blog-item').hide();
    $('.single-blog-item.'+target).show();
    $('.feature_blogg').hide();
  }
});

$('body').on('click',".js-load-more", function(){
  var $this =$(this),totalPages = parseInt($('[data-total-pages]').val()),currentPage = parseInt($('[data-current-page]').val());
  $this.attr('disabled', true);
  $this.find('[gfloader]').removeClass('morehide');
  currentPage = currentPage+1;
  var nextUrl = $('[data-next-url]').val().replace(/page=[0-9]+/,'page='+currentPage);
  $('[data-current-page]').val(currentPage);
  $.ajax({
    url: nextUrl,
    type: 'GET',
    dataType: 'html',
    success: function(responseHTML){
      $('.blog_grid_design').append($(responseHTML).find('.blog_grid_design').html());
    },
    complete: function() {
      if(currentPage <= totalPages) {
        $this.attr('disabled', false); $this.find('.view_all_btn').removeClass('morehide'); $this.find('[gfloader]').addClass('morehide');
      }
    }
  })
});

$('.shop_image_icon').on('click', function(){
  var data=$(this).data('attr');
  $('.shop_look_content').find('.'+data).addClass('current_active');
  $('.shop_look_content').find('.'+data).siblings().removeClass('current_active');
});

var btn = $('#Back_to_the__top');

$(window).scroll(function() {
  if ($(window).scrollTop() > 300) {
    btn.addClass('topshow');
  } else {
    btn.removeClass('topshow');
  }
});

btn.on('click', function() {
  $('html, body').animate({scrollTop:0}, '300');
});